import * as CQ from "@discovery/sonic-api-ng/lib/api/common/query";
export const defaultDecorators = CQ.Decorators.concat(CQ.Decorators.decorators("isFavorite"), CQ.Decorators.decorators("viewingHistory"));
export const config = {
    shareBaseURL: "https://www.discoveryplus.in",
    masthead: {
        item: {
            tag1Color: "282e3d",
            tag2Color: "282e3d",
        },
    },
    parentalLock: {
        recoveryQuestion1: "What is your favorite animal?",
        recoveryQuestion2: "What is the name of your birthplace?",
        timeoutInMinsForAutolock: 3,
    },
    standardPageRouteFragments: {
        allAccess: "/channel/all-access",
        contestLanding: "/contest/landing",
        contestParticipated: "/contest/participated",
        nativeViewAll: "/collection-view-all",
        setupName: "/setup-name",
        product: "/product",
        login: "/login",
        termsOfUse: "/terms-of-use" +
            `?displayFooter=false&displayMenu=false&displayHeader=false`,
        termsOfUseContest: "/contest-terms" +
            `?displayFooter=false&displayMenu=false&displayHeader=false`,
        home: "/home",
        search: "/search",
        signIn: "/sign-in",
        goPremium: "/go-premium-web",
        premium: "/premium",
        contest: "/contest",
    },
    standardPlaylists: {
        watchlistShorts: "dplus-watchlist-shorts",
        watchlistVideos: "dplus-watchlist-videos",
    },
    authenticationURLs: {
        contest: "/contest",
        contestWinners: "/leaderboard",
        myAccount: "/my-account",
        redeem: "/redeem",
        contestRoute: "/login?flow=OTPLogin&header=contest",
        contestRouteForSubscription: "/login?flow=purchase&header=contest",
        updatePaymentMethod: "/my-account/update-payment-method",
        authRedirect: "/auth-redirect",
    },
    userAttributes: {
        lastContestID: "lastContestIDUat",
        recentSearches: "dplusRecentSearches",
    },
    collectionConfiguration: {
        shortsAllVideos: "automated-shorts-collection",
        shortsPromotedVideos: "promoted-shorts",
        shortsTaxonomies: "shorts-taxonomies",
    },
    shorts: {
        isNewPublishIntervalInDays: 7,
    },
    footer: {
        fbUrlForFollowUs: "https://www.facebook.com/discoveryplusIN",
        youTubeUrlForFollowUs: "https://www.youtube.com/channel/UCXSu1hX5Rjtz1dOuEcJDTaQ?sub_confirmation=1",
        appStoreLink: "https://apps.apple.com/in/app/id1497257119",
        playStoreLink: "https://play.google.com/store/apps/details?id=com.discoveryplus.mobile.android",
        mailToDiscoveryPlus: "hello@discovery.com",
        discoveryPhoneNo: "022-43491100 (Mon-Fri, excluding Holidays 11am-4pm)",
        discoveryMobileNo: "",
        discoveryAddress2: "Discovery India, 5th Floor, WeWork BKC, C20 G Block, Bandra Kurla Complex, Mumbai 400051",
    },
    contest: {
        templateId: "descriptive",
        criteria: "premium",
    },
    subscriptionCTA: {
        label: "Buy Now",
        url: "/go-premium-web",
    },
};

